import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {AlertController, App, Events, LoadingController, NavController} from "ionic-angular";
import {AppStatsFoodUpdatePage} from "../../pages/app-stats-food-update/app-stats-food-update";
import {ApiProvider} from "../../providers/api/api";
import {AppFoodTrackingInfoPopupPage} from "../../pages/app-food-tracking-info-popup/app-food-tracking-info-popup";
import {LocalStorageWrapper} from "../../providers/local-storage-wrapper/local-storage-wrapper";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {Subscription} from "rxjs/Subscription";
import * as moment from "moment";

/**
 * Generated class for the StatsFoodPyramidCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'stats-food-pyramid-card',
  templateUrl: 'stats-food-pyramid-card.html'
})
export class StatsFoodPyramidCardComponent implements OnInit, OnChanges, OnDestroy {

  todaysData: any = {}
  groupLimits: any = {
    groupWater: 6,
    groupFruit: 2,
    groupVegetables: 3,
    groupGrainProducts: 4,
    groupMeatEgg: 1,
    groupMilkProducts: 3,
    groupNuts: 1,
    groupOilFat: 2,
    groupSnacks: 1
  }

  yesterdayCompletionClosed: boolean = false;
  completionClosed: boolean = false;

  aggrGroups: any = [
    ['groupWater', 'groupFruit', 'groupVegetables', 'groupGrainProducts'],
    ['groupOilFat', 'groupMeatEgg', 'groupMilkProducts', 'groupNuts'],
    ['groupSnacks']
  ]

  @Output() weeklyViewSwitch = new EventEmitter<boolean>()

  viewedDate: Date = new Date();

  @Input()
  dateMode: string;

  private foodSub: Subscription;
  private isInitialLoadDone: boolean = false;
  private foodUpdateHandler = () => {
    this.updateFoodData(false);
  };

  constructor(
    private navCtrl: NavController,
    private api: ApiProvider,
    private events: Events,
    private app: App,
    private alertCtrl: AlertController,
    private contentTranslation: ContentTranslationProvider,
    private localStorage: LocalStorageWrapper,
    private loadingCtrl: LoadingController,
    private userState: UserStateProvider,
  ) {
    this.events.subscribe('stats:food:update', this.foodUpdateHandler);

    let isTrendModalRegistered = (window as any).isTrendModalRegistered;
    if (!isTrendModalRegistered) {
      this.events.subscribe('app:show-food-trends', () => {
        let loader = this.loadingCtrl.create();
        loader.present();

        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 28)
        if(this.userState.user.createdAt > startDate.toISOString()) {
          const alert = this.alertCtrl.create({
            title: this.contentTranslation.translateContent("Food trend too young account title"),
            subTitle: this.contentTranslation.translateContent("Food trend too young account text"),
            buttons: [
              {
                text: 'OK',
              },
              {
                text: '×',
                cssClass: 'close-button'
              }

            ],
            cssClass: 'ip-alert ip-with-close'
          });
          alert.present();
          return ;
        }

        this.api.callGet('/users/' + this.userState.user.id + '/foodTrends').subscribe((response: any) => {
          let feedbackMessage = '';
          console.log(response);
          for (let message of response.messages) {
            feedbackMessage += '' +
              '<div class="feedback-section">' +
              '<span class="title">' + message.title + '</span>' +
              '<span class="text">' + message.text + '</span>' +
              '</div>';
          }

          loader.dismissAll();
          const alert = this.alertCtrl.create({
            title: '<img src="/assets/imgs/food-trend.png" /><span style="font-weight: 500;font-size: 24px; margin-top: 20px">' + this.contentTranslation.translateContent('Food trend title') + '</span>',
            subTitle: feedbackMessage,
            buttons: [
              {
                text: this.contentTranslation.translateContent('WEITER GEHT`S'),
                handler: _ => {
                }
              },
              {
                text: ' ',
                cssClass: 'back-button'
              }

            ],
            cssClass: 'ip-alert ip-with-close food-info-popup'
          });
          alert.present();


          console.log(response);
        })
      })
    }
    (window as any).isTrendModalRegistered = true;
  }

  switchView() {
    this.weeklyViewSwitch.emit(true);
  }

  ngOnInit() {
    if (!this.isInitialLoadDone) {
      this.viewedDate = this.dateMode === 'yesterday'
        ? moment().subtract(1, 'day').toDate()
        : moment().toDate();
      this.updateCardData();
      this.isInitialLoadDone = true;
    }
    this.loadFeedbackMessages();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dateMode']) {
      this.viewedDate = this.dateMode === 'yesterday'
        ? moment().subtract(1, 'day').toDate()
        : moment().toDate();
      this.updateCardData();
      this.isInitialLoadDone = true;
    }
  }

  ngOnDestroy() {
    if (this.foodSub) {
      this.foodSub.unsubscribe();
    }
    this.events.unsubscribe('stats:food:update', this.foodUpdateHandler);
  }

  feedbackMessages: Array<any>;

  loadFeedbackMessages() {
    if (this.feedbackMessages && this.feedbackMessages.length > 0) {
      return;
    }
    this.api.callGet('/pyramid_feedback_messages').subscribe((response: Array<any>) => {
      this.feedbackMessages = response;
    });
  }

  updateCardData() {
    let dateShort = moment(this.viewedDate).format('YYYY-MM-DD');
    this.completionClosed = (this.localStorage.getItem('pyramid-completion-' + dateShort) === 'true');
    this.yesterdayCompletionClosed = (this.localStorage.getItem('pyramid-completion-' + dateShort) === 'true');
    this.todaysData = {};
    this.updateFoodData(true);
  }

  isRedTipEmpty(stat: any): boolean {
    if (!stat) return false;
    let snacksCount = parseInt(stat.groupSnacks, 10) || 0;
    if (snacksCount > 0) {
      return false;
    }

    let hasFood = false;
    let foodKeys = [
      'groupWater', 'groupFruit', 'groupVegetables', 'groupGrainProducts',
      'groupMeatEgg', 'groupMilkProducts', 'groupNuts', 'groupOilFat'
    ];
    for (let key of foodKeys) {
      if ((parseInt(stat[key], 10) || 0) > 0) {
        hasFood = true;
        break;
      }
    }
    return hasFood;
  }

  getTotalPortions(stat: any): number {
    if (!stat) return 0;
    let sum = 0;
    for (let groupKey in this.groupLimits) {
      sum += (parseInt(stat[groupKey], 10) || 0);
    }
    return sum;
  }

  checkPastDaysRedTipChallenge(foodHistory: any) {
    if (!foodHistory) return;
    let checkDate = moment().subtract(1, 'day'); // Always starts strictly from yesterday (never today)
    for (let i = 0; i < 7; i++) {
      let dateStr = checkDate.format('YYYY-MM-DD');
      let stat = foodHistory[dateStr];
      if (stat && this.isRedTipEmpty(stat)) {
        let isMarkedClosed = (this.localStorage.getItem('pyramid-completion-' + dateStr) === 'true');
        let isSubstantialPastDay = (this.getTotalPortions(stat) >= 3);

        if (isMarkedClosed || isSubstantialPastDay) {
          this.events.publish('stats:food:tipEmptyYesterday');
          break;
        }
      }
      checkDate.subtract(1, 'day');
    }
  }

  updateFoodData(checkHistoryChallenges: boolean = false) {
    let todayYMD = moment(this.viewedDate).format('YYYY-MM-DD');
    console.log(todayYMD);

    let isSecondRowFilled = (stat) => {
      let aggr = true;
      for (let item of ['groupFruit', 'groupVegetables']) {
        if (parseInt(stat[item], 10) < this.groupLimits[item]) {
          aggr = false;
        }
      }
      return aggr;
    };

    let getSecondRowSum = (stat) => {
      let aggr = 0;
      for (let item of ['groupFruit', 'groupVegetables']) {
        aggr += parseInt(stat[item], 10);
      }
      return aggr;
    };

    if (this.foodSub) {
      this.foodSub.unsubscribe();
    }

    this.foodSub = this.api.callGet('/food').subscribe((response) => {
      if (todayYMD !== moment(this.viewedDate).format('YYYY-MM-DD')) {
        return;
      }

      let foodHistory: any = {};
      let currentDayData: any = null;

      for (let k in response) {
        let item = response[k];
        foodHistory[item.date] = item;
        if (item.date === todayYMD) {
          currentDayData = item;
        }
      }

      this.todaysData = currentDayData || {};

      let isFullPyramideFilled = (stat: any) => {
        if (!stat) return false;
        for (let groupKey in this.groupLimits) {
          if ((parseInt(stat[groupKey], 10) || 0) < this.groupLimits[groupKey]) {
            return false;
          }
        }
        return true;
      };

      for (let date in foodHistory) {
        if (isFullPyramideFilled(foodHistory[date])) {
          this.events.publish('stats:food:completed');
          break;
        }
      }

      if (currentDayData && isSecondRowFilled(currentDayData)) {
        this.events.publish('stats:food:second-row-filled');
      }

      // If the user has marked the currently viewed day completed with an empty red tip, trigger challenge
      if (this.completionClosed && this.isRedTipEmpty(this.todaysData)) {
        this.events.publish('stats:food:tipEmptyYesterday');
      }

      // Past history challenges: ONLY evaluated on initial load or date switch, never on single food updates
      if (checkHistoryChallenges) {
        this.checkPastDaysRedTipChallenge(foodHistory);

        let d = moment().subtract(1, 'day');
        let redTipEmptyCnt = 0;
        for (let i = 0; i < 10; i++) {
          let dateStr = d.format('YYYY-MM-DD');
          let stat = foodHistory[dateStr];
          if (!stat) {
            break;
          }
          let isMarkedClosed = (this.localStorage.getItem('pyramid-completion-' + dateStr) === 'true');
          let isSubstantialPastDay = (this.getTotalPortions(stat) >= 3);

          if (this.isRedTipEmpty(stat) && (isMarkedClosed || isSubstantialPastDay)) {
            redTipEmptyCnt++;
            if (i === 5 && redTipEmptyCnt === 6) {
              this.events.publish('stats:food:tipEmpty7Days');
            }
          }
          d.subtract(1, 'day');
        }

        d = moment();
        for (let i = 0; i < 10; i++) {
          let stat = foodHistory[d.format('YYYY-MM-DD')];
          if (!stat) {
            break;
          }
          let sum = 0;
          for (let groupKey in this.groupLimits) {
            sum += (parseInt(stat[groupKey], 10) || 0);
          }
          console.log(i, stat, sum);
          if (sum === 0) {
            break;
          }
          if (i === 2) {
            this.events.publish('stats:food:completedNDays', {days: 3});
          }
          if (i === 6) {
            this.events.publish('stats:food:completedNDays', {days: 7});
          }
          d.subtract(1, 'day');
        }

        d = moment();
        for (let i = 0; i < 10; i++) {
          let stat = foodHistory[d.format('YYYY-MM-DD')];
          d.subtract(1, 'day');
          let statPrev = foodHistory[d.format('YYYY-MM-DD')];
          console.log('check second row increase', i, stat, statPrev);
          if (!stat || !statPrev) {
            continue;
          }

          console.log('check second row increase', i, stat, statPrev, getSecondRowSum(stat), getSecondRowSum(statPrev));
          if (getSecondRowSum(stat) > getSecondRowSum(statPrev)) {
            this.events.publish('stats:food:secondRowIncreased');
          }
        }
      }
    });
  }

  openAddFoodModal() {
    this.app.getRootNav().push(AppStatsFoodUpdatePage, {date: this.viewedDate});
  }

  openFoodInfoPage() {
    this.app.getRootNav().push(AppFoodTrackingInfoPopupPage);
  }

  getComparisonForCategory(category) {
    let value = 0;
    let limit = 0;
    console.log(this.todaysData);
    if(category == 'green_first_row') {
      limit = 5;
      value = parseInt(this.todaysData.groupWater);
    } else if(category == 'green_second_row') {
      limit = 5;
      value = parseInt(this.todaysData.groupVegetables) + parseInt(this.todaysData.groupFruit);
    } else if (category == 'green_third_row') {
      limit = 4;
      value = parseInt(this.todaysData.groupGrainProducts)
    } else if (category == 'yellow_row') {
      limit = 4;
      value = parseInt(this.todaysData.groupMilkProducts) + parseInt(this.todaysData.groupMeatEgg);
    } else if (category == 'red_first_row') {
      limit = 2;
      value = parseInt(this.todaysData.groupOilFat);
    } else {
      limit = 1;
      value = parseInt(this.todaysData.groupSnacks);
    }
    if(isNaN(value)) {
      value = 0;
    }

    if(value > limit) {
      return 'overful';
    }
    if(value == limit) {
      return 'full';
    }
    if(value == 0) {
      return 'empty';
    }
    return 'partial';
  }

  shuffleArray(data) {
    for (var i = data.length - 1; i > 0; i--) {
      var rand = Math.floor(Math.random() * (i + 1));
      [data[i], data[rand]] = [data[rand], data[i]];
    }
  }

  updateCompletionParameter() {
    let dateShort = moment(this.viewedDate).format('YYYY-MM-DD');
    this.localStorage.setItem('pyramid-completion-' + dateShort, this.completionClosed ? 'true' : 'false');
    this.updateFoodData(false);

    if (!this.completionClosed) {
      return;
    }

    if (this.isRedTipEmpty(this.todaysData)) {
      this.events.publish('stats:food:tipEmptyYesterday');
    }

    let feedbackMessage = '';
    let ids = ['green_first_row', 'green_second_row', 'green_third_row', 'yellow_row', 'red_first_row', 'red_second_row'];

    this.shuffleArray(ids);
    if (this.feedbackMessages) {
      this.shuffleArray(this.feedbackMessages);
    }

    ids = ids.slice(0, 2);

    console.log(this.todaysData);
    for (let id of ids) {
      let comparison = this.getComparisonForCategory(id);
      let foundMessages = (this.feedbackMessages || []).filter(m => {
        return m.category == id && m.comparison == comparison;
      });

      if (foundMessages.length) {
        feedbackMessage += '' +
          '<div class="feedback-section">' +
          '<span class="title">' + foundMessages[0].title + '</span>' +
          '<span class="text">' + foundMessages[0].text + '</span>' +
          '</div>';
      } else {
        feedbackMessage += '<div>Missing message for ' + this.contentTranslation.translateContent('food ' + id) + ' comparison ' + comparison + '</div>';
      }
    }

    const alert = this.alertCtrl.create({
      title: '<img src="/assets/imgs/food-trend.png" /><span style="font-weight: 500;font-size: 24px; margin-top: 20px">' + this.contentTranslation.translateContent('Food daily summary') + '</span>',
      subTitle: feedbackMessage,
      buttons: [
        {
          text: this.contentTranslation.translateContent('WEITER GEHT`S'),
          handler: _ => {
          }
        },
        {
          text: ' ',
          cssClass: 'back-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close food-info-popup'
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/stats-food-pyramid-card/stats-food-pyramid-card.ts